import React from "react";
import useLogin from "./useLogin";
import Card from "../../component/Card";
import loginLogo from "../../assets/login-logo.png";
import bgImage from "../../assets/bg-image.jpg";

const LoginPage = () => {
  const { mobileNumber, handleMobileNumberChange, handleLogin, signUpHandler } =
    useLogin();
  return (
    <div
      className="flex flex-col h-screen"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: "cover" }}
    >
      <div className="absolute inset-0 bg-cyan-950 opacity-90"></div>
      <div className="flex h-20 bg-white mt-3 z-20 items-center px-10">
        <img
          src="https://nxgcreator.s3.ap-south-1.amazonaws.com/ayurGroup%20512.png"
          alt="logo"
          style={{ width: "60px", height: "60px" }}
        />
        <span className="text-xl font-bold ml-2"> Ayur Guide</span>
      </div>
      <div className=" flex items-center justify-center z-10 h-screen h-[calc(100vh - 100px)]">
        <div className="flex gap-20 p-20 rounded bg-white">
          <img src={loginLogo} alt="login" className="h-52 " />
          <div className="flex flex-col gap-5">
            <span className="text-2xl font-semibold">Welcome Back!</span>
            <span className="text-gray-500">
              Sign in to application for more learning.
            </span>
            <div className="flex flex-col">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="phone"
              >
                Mobile Number
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                  <img
                    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/in.svg"
                    alt="IN"
                    className="w-4 h-3 mr-2"
                  />
                  +91
                </span>
                <input
                  id="phone"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  type="tel"
                  className="shadow appearance-none border rounded w-full py-2 px-3 pl-16 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Enter mobile number"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 items-center justify-center w-full">
              <button
                className="bg-emerald-500 uppercase mb-3 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleLogin}
              >
                Sign in
              </button>
              {/* <span className="text-gray-500">Didn't Have An Account?</span>
              <button
                onClick={signUpHandler}
                className="inline-block align-baseline font-bold text-sm text-emerald-500 hover:text-emerald-600"
              >
                Sign up Now
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
